export const EFFECT = 'EFFECT';
export const SEQUENCER = 'SEQUENCER';
export const PART = 'PART';
